import dayjs from 'dayjs';

export default function (value) {
    const formattedDate = dayjs(value, 'DD/MM/YYYY', true).format('YYYY-MM-DD');
    const age = dayjs().diff(formattedDate, 'year', false);
    return age >= 18;
}
